import Product from '@grafikr/shopify-typescript/type/object/Product';
import Variant from '@grafikr/shopify-typescript/type/object/Variant';
import { component } from 'picoapp';
import formatMoney from 'utils/format-money';
import OptionSelector from 'utils/option-selector';

export default component((node) => {
  const data: Product = JSON.parse(node.querySelector('[data-data]').textContent);

  const initOptions = () => {
    const addToCart = node.querySelector<HTMLButtonElement>('[data-add-to-cart]');
    const price = node.querySelector<HTMLElement>('[data-price]');
    const compareAtPrice = node.querySelector<HTMLElement>('[data-compare-at-price]');
    const forms = node.querySelectorAll<HTMLFormElement>('form[action="/cart/add"]');

    forms.forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const target = event.target as HTMLFormElement;
        const formdata = new FormData(target);
        formdata.set('properties[_uniqueprod]', Date.now().toString());

        await fetch(`${target.action}.js`, {
          method: target.method,
          body: formdata,
        });

        const evt: CustomEvent<{ image: string | null; }> = new CustomEvent('cart:product:update');
        document.dispatchEvent(evt);
      });
    });

    const callback = (variant: Variant | null) => {
      if (variant) {
        price.textContent = `${formatMoney(variant.price).removeTrailingZeros()}`;

        if (variant.compare_at_price > variant.price) {
          compareAtPrice.hidden = false;
          compareAtPrice.innerHTML = `${formatMoney(variant.compare_at_price).removeTrailingZeros()}`;
        } else {
          compareAtPrice.hidden = true;
        }

        // if (variant.available) {
        //   addToCart.textContent = theme.strings.addToCart;
        //   addToCart.disabled = false;
        // } else {
        //   addToCart.textContent = theme.strings.soldOut;
        //   addToCart.disabled = true;
        // }
      } else {
        addToCart.textContent = theme.strings.unavailable;
        addToCart.disabled = true;
      }
    };

    OptionSelector(`#product-${data.id}`, {
      data,
      onVariantSelected: callback,
    });
  };

  initOptions();
});
